import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';

import { observable } from 'mobx';
import { Localize } from './Localize';
import {CircleAvatar} from './CircleAvatar';
import { TextStroke } from './TextStroke';
import { ButtonMover } from './Buttons';
import { Checkbox } from './Checkbox';
import { ProgressBar } from './ProgressBar';
import { comm } from '../comm';
import { i18n } from '../i18n';
import { Sprite } from './Sprite';
import { integration } from '../integration';
import { B64Image } from './B64Image';


const Profile = styled.div`
	width: 100%;
	height: 100%;

	font-family: Jost, Arial, Helvetica, sans-serif;

	font-size: 12px;
	align-items: stretch;
	margin-top: 15vw;
	border-bottom: 1px solid gray;
	background: rgba(0,0,0,0.5);
	/* background-color: white; */

	& > div {
		flex-grow: 1;
	}
	& > .opponent {
		text-align: left;
	}
`

const Inner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	@media (min-aspect-ratio: 9/15){
		transform: scale(0.75) translateY(-25vw);
	}
`

const Row = styled.div`
	display: block;
	position: relative;
	text-align: center;
	line-height: 0px;
	width: 96vw;
`

const PlayerStats = styled.div`
	height: 96%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`

const Stats = styled.div`
	display: flex;
	align-items: flex-start;
	flex: 0 0 25vw;
	text-align: left;
	height: 25vw;
	& > div {
		flex-grow: 1;
		display: flex;
	}
`
const NameAndTrophies = styled.div`
	display: flex;
	color: white;
	flex-grow: 1;
	line-height: 1.5em;
	& > div {
		flex-grow: 1;
		display: flex;
	}
`

const ProfileHeader = styled(Sprite)`
	width: 80vw;
	position: relative;
	top: 6vw;
	z-index: 10;
`
const Close = styled.img`
	width: 10vw;
	position: absolute;
	top: 3vw;
	right: 11vw;
	z-index: 20;
`

const Content = styled.div`
	width: 96vw;
	height: 98.85vw;
	background-image: url('/assets/profile/content_bg.png');
	background-size: 100% 100%;
	line-height: 0px;
	background-repeat: no-repeat;
	position: relative;
	top: -1px;
`

const ContentInner = styled.div`
	padding: 0vw 7vw;
	line-height: 1.5em;
	height: 100%;
`

const TrophiesBox = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	flex-grow: 0;
	width: 22vw;
	box-sizing: border-box;
	& > div {
		flex-direction: row;
		display: flex;
		justify-content: space-around;
	}
`

const Trophies = styled.img`
	width: 100%;
`

const TrophyCounts = styled.div`
	position: absolute;
	width: 100%;
	bottom: 0;
	display: flex;
	flex-direction: column;
	& > div {
		flex: 1 1 1px;
		text-align: center;
	}
`

const Actions = styled.div`
	margin-top: 4vw;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	justify-items: center;
	& img {
		width: 25vw;
	}
`

const FbButton = styled(B64Image)`

`

const Legals = styled.div`
	position: relative;
	margin-bottom: 3vw;
`

const LegalButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	justify-items: center;
	width: 94%;
	margin: 0 3%;
	height: 8.5vw;
	& > img {
		width: 23vw;
	}
`

const IconBar = styled.div`
	height: 100%;
	width: 100%;
	padding-left: 7vw;
	position: relative;
	& > img {
		position: absolute;
		top: 0;
		left: 0;
	}
	display: flex;
	align-items: center;
	justify-content: flex-end;
`
const Bar = styled.div`
	width: 100%;
	height: 54%;
	margin-bottom: 7%;
	box-sizing: border-box;
	overflow: hidden;
`

const BarWrap = styled.div`
	transform: translate3d(0,0,0);
	display: flex;
	height: 15vw;
	width: 100%;
	flex-shrink: 0;
	flex-grow: 0;
	flex-direction: row;
	align-items: center;
	font-size: 3vw;
	overflow: hidden;
`

const Settings = styled.div`
	display: flex;
	flex-direction: column;
	background-image: url('/assets/profile/profile_panel_1.png');
	background-size: 134% auto;
`

const Setting = styled.div`
	display: flex;
	flex-direction: row;
	height: 11.395vw;
    margin-bottom: 0.3vw;
	font-size: 3vw;
	overflow: hidden;
	& > div {
		flex: 1 1 auto;
		padding: 1vw 3vw;
		color: white;
		font-size: 4.6vw;
		line-height: 1.5em;
		text-shadow: 0.3vw 0.3vw 0.3vw #120410, -0.3vw -0.3vw 0.3vw #120410, 0.3vw -0.3vw 0.3vw #120410, -0.3vw 0.3vw 0.3vw #120410;
		display: flex;
		align-items: center;
	}
	& > div > img.button{
		height: 7vw;
		margin-top: .5vw;
	}
	& > div:last-child {
		justify-content: flex-end;
	}
	& .sa_checkbox {
		height: 10vw;
	}
	& .sa_checkbox {
		margin-left: 3vw;
	}
`

const LevelStar = styled.div`
	position: absolute;
	top: 0;
	left: 1vw;
	background-image: url("/assets/profile/profile_star.png");
	background-size: cover;
	height: 10vw;
	width: 10vw;
	font-size: 5vw;
	padding-top: 1vw;
	box-sizing: border-box;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	text-shadow: 2px 2px 2px rgba(0,0,0,1);
`

const ToSBody = styled.div`
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
	padding-top: 15vw;
`

const ToSButton = styled.button`
	background-color: #ccc;
	color: black;
	padding: 3vw;
	flex: 0 0 3vw;
`

const ToSFrame = styled.iframe`
	flex-grow: 1;
	background-color: white;
`

const GameCenterButton = styled(B64Image)`
	margin-top: 4vw;
	width: 60vw;
`

const PlusFiveHeart = styled(B64Image)`
	position: absolute;
	bottom: -1vw;
	right: -2vw;
	width: 8vw !important;
`

@observer
export class PlayerProfile extends Component {
	@observable tabIndex = 0;

	componentDidMount() {
		integration.postAnalyticsEvent(`profile_view`, `navigation`);
		integration.postAnalyticsEvent(`profile_loaded`, `user_experience`);
	}

	close = () => {
		window.manager.playAudio("poopPop");
		store.showProfile = false;
	}

	faq = () => {
		// if(store.phaserReady)
		window.manager.playAudio("poopPop");
		store.showProfile = false;
		store.modal = 'learn';
	}

	showAchievements = () => {
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_view_achievements_button`, `navigation`);
		store.showAchievements = true;
	}
	clickTOS() {
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_tos_view`, `navigation`);
	}
	clickPP() {
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_pp_view`, `navigation`);
	}
	clickFaq() {
	window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_view_FAQs`, `navigation`);
	}
	facebookDisconnect(){
		window.manager.playAudio("poopPop");
		// window.WrapperApp.postMessage('calling disconnect');
		store.user.facebook.disconnect();
	}

	facebookConnect(){
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_fb_connect`, `navigation`);
		// window.WrapperApp.postMessage('calling connect');
		// window.store.debugArray.push(`341 calling wrapper fblogin`);
		window.WrapperApp.postMessage('fblogin');
	}

	appleDisconnect(){
		// if(store.phaserReady)
			window.manager.playAudio("poopPop");
		// window.WrapperApp.postMessage('calling disconnect');
		store.user.loginMethod = 'guest';
		window.WrapperApp.postMessage('apple-logout');
		store.user.apple.disconnect();
	}

	appleConnect(){
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`profile_apple_login`, `navigation`);
		window.WrapperApp.postMessage('apple-login');
	}

	registerForNotifications(){
		if(store.fcmId){
			comm.RegisterFCM(store.fcmId)
			.then((result) => {
				console.log('registerFCM complete');
				return result;
			});
		}
	}

	unregisterForNotifications(){
		comm.UnregisterFCM().then(() => {console.log('unregisterFCM complete');});
	}

	changeLanguage = () => {
		if(!store.phaserLoading){
			window.manager.playAudio("poopPop");
			store.modal = 'settingsLanguage';
			integration.postAnalyticsEvent('settings_change_lang','settings');
		}
	}

	state = {
		preloading: true,
		iframe: ""
	};

	close() {
		window.manager.playAudio("poopPop");
		this.setState({iframe: ""});
	}

	changeTab(i){
		window.manager.playAudio("poopPop");
		this.tabIndex = i;
		let label = i === 0 ? 'profile_view_stats' : 'profile_view_settings';
		integration.postAnalyticsEvent(label, `navigation`);
	}

	rateUs = () => {
		window.manager.playAudio("poopPop");
		window.WrapperApp.postMessage('rate-us');
		integration.postAnalyticsEvent('settings_rate_us','settings');
	}

	toggleSound = () => {
		store.changeSetting('sound');
		integration.postAnalyticsEvent(`settings_sound_${store.settings.sound ? 'on' : 'off'}`)
	}

	toggleMusic = () => {
		store.changeSetting('music')
		integration.postAnalyticsEvent(`settings_music_${store.settings.music ? 'on' : 'off'}`)
	}

	toggleNotifications = () => {
		store.changeSetting('notifications');
		//debugger;
		integration.postAnalyticsEvent(`settings_notifications_${store.settings.notifications ? 'on' : 'off'}`)
		if(store.settings.notifications){
			this.registerForNotifications();
		} else {
			this.unregisterForNotifications();
		}
	}

	toggleVibration = () => {
		store.changeSetting('vibration')
		integration.postAnalyticsEvent(`settings_vibrate_${store.settings.vibration ? 'on' : 'off'}`)
	}

	prevent(e){
		e.stopPropagation();
		// e.preventDefault();
	}

	render(){
		const isFacebook = !!store.user.facebook.isConnected; //store.user.loginMethod === 'facebook';
		// const isGoogle = false;
		const isApple = store.user.apple.isConnected;
		const isGuest = store.user.guest.isConnected;
		const userImage = store.user.image || '/assets/profile/profile_default.jpg';
		var on = i18n.t('on');
		var off = i18n.t('off');

		if(this.state.iframe){
			return(
				<ToSBody>
					<ToSButton opacity={1} onClick={() => {this.close()}}>Close</ToSButton>
					<ToSFrame title="terms" src={this.state.iframe}/>
				</ToSBody>
			);
		}

		return (
			<Profile key={"profile-"+store.settings.language}
				onClick={this.prevent}
				onMouseDown={this.prevent}
				onMouseUp={this.prevent}
				onTouchStart={this.prevent}
				onPointerUp={this.prevent}
				onPointerDown={this.prevent}
			>
				<Inner>
					<Row>
						<ProfileHeader w={80} localize sprite="profile_banner_english.png"/>
						<Close onClick={this.close} src="/assets/btn_close.png"/>
					</Row>
					{this.tabIndex === 0 ? (
						<Sprite localize w={96} sprite="profile_tab_1.png" onClick={() => this.changeTab(1)} />
					) : (
						<Sprite localize w={96} sprite="profile_tab_2.png" onClick={() => this.changeTab(0)} />
					)}
							{this.tabIndex === 0 && (
					<Content>
						<ContentInner>
								<PlayerStats>
									<Stats>
										<div style={{flexGrow: 0, marginRight: '2vw'}}>
											<CircleAvatar img={userImage} vw={18} />
										</div>
										<div style={{flexDirection: 'column', fontSize:'5vw'}}>
											<NameAndTrophies>
												<div style={{flexDirection: 'column', flexGrow: 1}}>
													<div><TextStroke color="#522004">{isGuest ? store.user.anonName : store.user.name}</TextStroke></div>
													<div><TextStroke color="#522004"><Localize phrase="level"/> {store.user.level}</TextStroke></div>
												</div>
												<TrophiesBox style={{textAlign:'center'}}>
													<Trophies src="/assets/profile/profile_trophies.png"/>
													<TrophyCounts>
														<div><TextStroke color="#522004">{store.user.trophies[0]}</TextStroke></div>
														<div><TextStroke color="#522004">{store.user.trophies[1]}</TextStroke></div>
														<div><TextStroke color="#522004">{store.user.trophies[2]}</TextStroke></div>
													</TrophyCounts>
												</TrophiesBox>
											</NameAndTrophies>
											<BarWrap>
												<IconBar>
													<Bar>
														<ProgressBar percent={store.user.xpData.currentPercentage}>
															{store.user.xpData.currentProgress[0]}/{store.user.xpData.currentProgress[1]}
														</ProgressBar>
													</Bar>
												<LevelStar>{store.user.level}</LevelStar>
												</IconBar>
											</BarWrap>
										</div>
									</Stats>
									<Actions style={store.isAndroid ? {
										justifyContent: 'space-evenly'
									} : {}}>
										<ButtonMover onClick={() => this.showAchievements()}>
											<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_achievements.png`}/>
										</ButtonMover>
										<ButtonMover onClick={isFacebook ? this.facebookDisconnect : this.facebookConnect}>
											<FbButton src={isFacebook ? `/assets/languages/${store.settings.language}/profile_fb_disconnect.png` : `/assets/languages/${store.settings.language}/profile_fb_connect.png`}/>
											{!isFacebook && <PlusFiveHeart src="/assets/FB_reward_heart_plus_five.png"/>}
										</ButtonMover>
										{false && store.isAndroid && (
											<ButtonMover>
												<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_google_connect_coming_soon.png`}/>
											</ButtonMover>
										)}
										{store.isIOS && (
											<ButtonMover onClick={isApple ? this.appleDisconnect : this.appleConnect}>
												<img draggable="false" alt=""
													src={isApple ? `/assets/languages/${store.settings.language}/profile_apple_disconnect.png` : `/assets/languages/${store.settings.language}/profile_apple_connect.png`}/>
											</ButtonMover>
										)}
									</Actions>
									<Legals>
										<Sprite style={{marginBottom: '2vw'}} localize w={100} unit="%" sprite={`profile_legal.png`}/>
										<LegalButtons>
											<Sprite localize draggable="false" alt="" sprite={`profile_btn_terms_of_service.png`}
												onClick={() => { this.clickTOS(); this.setState({iframe: "/tos.html"})}}
											/>
											<Sprite localize draggable="false" alt="" sprite={`profile_btn_privacy_policy.png`}
												onClick={() => { this.clickPP();  this.setState({iframe: "/pp.html"})}}
											/>
											<Sprite localize draggable="false" alt="" sprite={`profile_btn_faq.png`}
												onClick={() => { this.clickFaq();  this.setState({iframe: "https://www.shakeitupdice.com/gamefaq.html"})}}
											/>
										</LegalButtons>
									</Legals>
								</PlayerStats>
							</ContentInner>
						</Content>
					)}
					{this.tabIndex === 1 && (
						<Content style={{
							height: '111.85vw'
						}}>
							<ContentInner>
								<div style={{width:'100%', height: '100vw'}}>
									<Settings>
										<Setting>
											<div>{i18n.t('Enjoying the Game?')}</div>
											<div>
												<img className="button" draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_btn_rate_us.png`}
													onClick={this.rateUs}
												/>
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Sound Effects")}</div>
											<div>
												{store.settings.sound ? on : off}
												<Checkbox onClick={this.toggleSound} toggle={store.settings.sound}/>
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Music")}</div>
											<div>
												{store.settings.music ? on : off}
												<Checkbox onClick={this.toggleMusic} toggle={store.settings.music}/>
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Language")}: {i18n.t('lang-'+store.settings.language)}</div>
											<div>
												<img className="button" draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_btn_change.png`}
													onClick={this.changeLanguage}
												/>
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Notifications")}</div>
											<div>
												{store.settings.notifications ? on : off}
												<Checkbox toggle={store.settings.notifications} onClick={this.toggleNotifications} />
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Dice Throw Vibration")}</div>
											<div>
												{store.settings.vibration ? on : off}
												<Checkbox onClick={this.toggleVibration} toggle={store.settings.vibration}/>
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("Version Number")}</div>
											<div style={{fontSize: '4vw', fontFamily: 'monospace'}}>
												{store.wrapperVersion}.{store.gameVersion}
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t("User ID")}</div>
											<div style={{fontSize: '3vw', lineHeight: '1em', fontFamily: 'monospace'}}>
												{store.user.guest.localData.id.slice(0, store.user.guest.localData.id.length / 2).toUpperCase()}<br/>
												{store.user.guest.localData.id.slice(store.user.guest.localData.id.length / 2).toUpperCase()}
											</div>
										</Setting>
										<Setting>
											<div>{i18n.t('Player ID')}</div>
											<div>{store.user.guest.serverData.UserId}</div>
										</Setting>
										{/* <Setting>
											<div>{i18n.t("Credits")}</div>
											<div>
												<img className="button" draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_btn_view.png`}
													onClick={() => { window.manager.playAudio("poopPop"); }}
												/>
											</div>
										</Setting> */}
									</Settings>
									<div style={{display: "flex", justifyContent: "center"}}>
										{false && store.isAndroid && (
											<GameCenterButton draggable="false" alt="" src={`/assets/languages/${store.settings.language}/profile_btn_view_google_play.png`}
												onClick={() => { window.manager.playAudio("poopPop"); }}
											/>
										)}
									</div>
								</div>
							</ContentInner>
						</Content>
					)}
				</Inner>
			</Profile>
		);
	}
}
